(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1618-editorial-header"]) return;
  try {
    
document.addEventListener('click', function(event) {
  document.querySelectorAll('.ed-menu[open]').forEach(function(menu) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') document.querySelectorAll('.ed-menu[open]').forEach(function(menu) {menu.removeAttribute('open');menu.querySelector('summary').focus();});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1618-feature-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('feature-carousel')){
customElements.define('feature-carousel',class extends HTMLElement{
connectedCallback(){
 const rail=this.querySelector('.feature-carousel__rail'),prev=this.querySelector('[data-feature-prev]'),next=this.querySelector('[data-feature-next]');
 this.events=new AbortController();const options={signal:this.events.signal};
 const update=()=>{prev.disabled=rail.scrollLeft<2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2};
 const move=direction=>{const card=rail.querySelector('.feature-carousel__card');if(card)rail.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})};
 prev.addEventListener('click',()=>move(-1),options);next.addEventListener('click',()=>move(1),options);
 rail.addEventListener('scroll',update,{...options,passive:true});rail.addEventListener('keydown',event=>{if(event.target===rail&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowLeft'?-1:1)}},options);
 this.resize=new ResizeObserver(update);this.resize.observe(rail);update();
}
disconnectedCallback(){this.events?.abort();this.resize?.disconnect()}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["1618-line-banner"]) return;
  try {
    
(() => {
  const mountLineMenuBanner = () => {
    document.querySelectorAll('.line-header-icon').forEach(icon => icon.remove());
    const template = document.querySelector('[data-line-menu-template]');
    const menu = document.querySelector('.ed-menu-panel') || document.querySelector('#menu-drawer .menu-drawer__navigation');
    if (!menu) return;
    menu.querySelector('.line-menu-banner')?.remove();
    if (template) menu.prepend(template.content.firstElementChild.cloneNode(true));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountLineMenuBanner, {once:true});
  else mountLineMenuBanner();
  document.addEventListener('shopify:section:load', mountLineMenuBanner);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
